import React from 'react';
import { SchoolsGalleryProps } from '../../../component-props';
import { School } from '@greystar/lib';
import { FaLocationArrow } from 'react-icons/fa';

interface SchoolCardProps {
  title: string;
  titleLink: string;
  subtitle: string;
  grade: string;
  students: string;
  icon: React.ComponentType<{
    style?: {
      color?: string;
      fontSize?: string;
    };
  }>;
  zone: string;
  schoolScore: number;
  OutofScore: number;
}
const transformProps = (schools: School[]): SchoolCardProps[] => {
  const transformedSchools: SchoolCardProps[] = [];

  schools.forEach((school) => {
    const levels = school.level.split(',');
    transformedSchools.push({
      title: school.name,
      titleLink: school['web-site'] ?? school['overview-url'],
      subtitle: `${school.street}, ${school.city}`,
      grade: `${levels[0]}-${levels[levels.length - 1]}`,
      students: '',
      icon: FaLocationArrow,
      zone: 'Nearby zone',
      schoolScore: school.rating ? parseInt(school.rating) : 0,
      OutofScore: 10,
    });
  });

  return transformedSchools;
};

export const SchoolsGallery = (props: SchoolsGalleryProps): JSX.Element => {
  /*  To do when actual component developed */

  const privateSchoolCards = transformProps(
    props.schools.filter((school) => school.type === 'private')
  );
  const publicSchoolCards = transformProps(
    props.schools.filter((school) => school.type === 'public')
  );

  console.log(privateSchoolCards, publicSchoolCards);
  return (
    <div>
      {/*  To do when actual component developed */}
      <span>School Info</span>
    </div>
  );
};
